<div class="pt-3 sm:flex items-center">
  @if (inputType != 'separator') {
    <dt [ngClass]="{'opacity-0': inputType == 'button', 'hidden sm:!flex': inputType == 'button'}"
        class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 mb-0"
    >
      {{ (settingsInputElementModel.propertyTitleFunction ? settingsInputElementModel.propertyTitleFunction() : settingsInputElementModel.propertyTitle) }}
    </dt>
  }
  <dd class="mt-2 sm:mt-1 flex justify-end gap-x-6 sm:mt-0 sm:flex-auto items-center">

    <div class="relative sm:col-span-2  flex-full flex flex-grow items-stretch focus-within:z-10">
      @if (validAndChangedInput === ChangeValueStatus.Changed && inputType != 'separator' || (validAndChangedInput !== ChangeValueStatus.Unchanged && inputType == 'checkbox' && settingsInputElementModel.changeableProperties.newPropertyValue == true)) {
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <svg class="bi bi-bookmarks fill-green-700" height="16" viewBox="0 0 16 16" width="16"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
          </svg>
        </div>
      }

      @if (validAndChangedInput === ChangeValueStatus.Invalid && inputType != 'separator' || (validAndChangedInput !== ChangeValueStatus.Unchanged && inputType == 'checkbox' && settingsInputElementModel.changeableProperties.newPropertyValue == false)) {
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <svg class="bi bi-bookmarks fill-red-700" height="16" viewBox="0 0 16 16" width="16"
               xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
          </svg>
        </div>
      }

      @if (validAndChangedInput === ChangeValueStatus.Unchanged && inputType != 'separator') {
        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <svg class="bi bi-bookmarks fill-gray-500" height="16" viewBox="0 0 16 16" width="16"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z" fill-rule="evenodd"/>
          </svg>
        </div>
      }

      @if (inputType) {
        <div class="flex w-full">
          @switch (inputType) {
            @case ('dropdown') {
              <ng-select (ngModelChange)="setNewValueEvent($event)"
                         [clearable]="settingsInputElementModel.isClearable"
                         [items]="settingsInputElementModel.items"
                         [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue"
                         bindLabel="item2"
                         bindValue="item1" class="w-full" notFoundText="Keine Ergebnisse">

              </ng-select>
            }
            @case ('textarea') {
              <!-- The visible caption is a <dt>, which names nothing — label the control explicitly. -->
              <textarea #SettingsInput
                        (ngModelChange)="setNewValueEvent($event)"
                        [attr.aria-label]="title"
                        [disabled]="!settingsInputElementModel.changeableProperties.editMode"
                        [ngClass]="{' safari-disabled-color': platformScannerService.getPlatform() == Platform.Safari}"
                        [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue"
                        class="block w-full rounded-md border-0 py-1.5 pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 "
                        rows="5"
              ></textarea>
            }
            @case ('checkbox') {
              <input #SettingsInput
                     (click)="settingsInputElementModel.changeableProperties.newPropertyValue = !settingsInputElementModel.changeableProperties.newPropertyValue; validAndChangedInput = settingsInputElementModel.changeableProperties.newPropertyValue ? ChangeValueStatus.Changed : ChangeValueStatus.Invalid;"
                     (ngModelChange)="setNewValueEvent($event)"
                     [attr.aria-label]="title"
                     [disabled]="!settingsInputElementModel.changeableProperties.editMode"
                     [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue ? 'wahr' : 'falsch'"
                     class="block w-full text-start rounded-md border-0 py-1.5 pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 "
                     type="button">
            }
            @case ('button') {
              <button #SettingsInput
                      (click)="settingsInputElementModel.changeableProperties.newPropertyValue = '*changed';
              settingsInputElementModel.changeableProperties.editMode = true;
              hasValueChanged()"
                      [ngClass]="{' safari-disabled-color': platformScannerService.getPlatform() == Platform.Safari}"
                      class="block w-full rounded-md border-0 py-1.5 pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 "
              >{{ (settingsInputElementModel.propertyTitleFunction ? settingsInputElementModel.propertyTitleFunction() : settingsInputElementModel.propertyTitle) }}
              </button>
            }
            @case ('separator') {
              <div class="w-full grid grid-cols-1 pt-4">
                @if ((settingsInputElementModel.propertyTitle && settingsInputElementModel.propertyTitle != '') || (settingsInputElementModel.propertyTitleFunction)) {
                  <span
                    class="text-lg fw-light">{{ (settingsInputElementModel.propertyTitleFunction ? settingsInputElementModel.propertyTitleFunction() : settingsInputElementModel.propertyTitle) }}</span>
                }
                <!--
                  `rounded-[0.25rem]`, NOT Bootstrap's `rounded-1` (Bug #234) — and deliberately NOT the
                  obvious-looking `rounded` either. Bootstrap's `.rounded-1` is
                  `border-radius: var(--bs-border-radius-sm) !important` = 0.25rem, which happens to equal
                  Tailwind's `rounded`; but `.rounded` is ITSELF a Bootstrap class
                  (`var(--bs-border-radius)` = 0.375rem, `!important`), so writing `rounded` would swap one
                  Bootstrap utility for another AND grow the radius by 50%. Tailwind has no non-colliding
                  name for 0.25rem, hence the arbitrary value. Verified against
                  node_modules/bootstrap/dist/css/bootstrap.min.css. No visual change: the bar is 2px tall,
                  so the radius is clamped to a pill end either way.
                -->
                <div class="bg-gray-300 w-full h-0.5 rounded-[0.25rem]"></div>
              </div>
            }
            @case ('address') {
              <!--
                Inside a `@case`, Angular NARROWS `inputType` to that literal — `*ngSwitchCase` did not. The
                sub-fields' old `[ngClass]` tested `inputType == 'datetime-local'`, which is provably false
                here and now fails the AOT build (TS2367) rather than silently evaluating to false. The
                conditional is therefore resolved by hand to the branch it always took: no `pt-2`, always
                `py-1.5` (moved into the static class list). Rendering is unchanged.
              -->
              <div class="w-full grid grid-cols-1 pl-10">
          <input #SettingsInput
                 (ngModelChange)="settingsInputElementModel.changeableProperties.newPropertyValue!.street = $event;setNewValueEvent(settingsInputElementModel.changeableProperties.newPropertyValue)"
                 [disabled]="!settingsInputElementModel.changeableProperties.editMode"
                 [ngClass]="{' safari-disabled-color': platformScannerService.getPlatform() == Platform.Safari}"
                 [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue?.street"
                 [type]="inputType"
                 class="block w-full rounded-t-md border-0 py-1.5 pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 "
                 placeholder="Street">
          <input #SettingsInput
                 (ngModelChange)="settingsInputElementModel.changeableProperties.newPropertyValue!.houseNumber = $event;setNewValueEvent(settingsInputElementModel.changeableProperties.newPropertyValue)"
                 [disabled]="!settingsInputElementModel.changeableProperties.editMode"
                 [ngClass]="{' safari-disabled-color': platformScannerService.getPlatform() == Platform.Safari}"
                 [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue?.houseNumber"
                 [type]="inputType"
                 class="block w-full rounded-t-md border-0 py-1.5 pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 "
                 placeholder="House Number">
          <input #SettingsInput
                 (ngModelChange)="settingsInputElementModel.changeableProperties.newPropertyValue!.additionalAddressLine = $event;setNewValueEvent(settingsInputElementModel.changeableProperties.newPropertyValue)"
                 [disabled]="!settingsInputElementModel.changeableProperties.editMode"
                 [ngClass]="{' safari-disabled-color': platformScannerService.getPlatform() == Platform.Safari}"
                 [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue?.additionalAddressLine"
                 [type]="inputType"
                 class="block w-full border-0 py-1.5 pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 "
                 placeholder="Additional Address Line">
          <input #SettingsInput
                 (ngModelChange)="settingsInputElementModel.changeableProperties.newPropertyValue!.zip = $event;setNewValueEvent(settingsInputElementModel.changeableProperties.newPropertyValue)"
                 [disabled]="!settingsInputElementModel.changeableProperties.editMode"
                 [ngClass]="{' safari-disabled-color': platformScannerService.getPlatform() == Platform.Safari}"
                 [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue?.zip"
                 [type]="inputType"
                 class="block w-full border-0 py-1.5 pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 "
                 placeholder="ZIP">
          <input #SettingsInput
                 (ngModelChange)="settingsInputElementModel.changeableProperties.newPropertyValue!.city = $event;setNewValueEvent(settingsInputElementModel.changeableProperties.newPropertyValue)"
                 [disabled]="!settingsInputElementModel.changeableProperties.editMode"
                 [ngClass]="{' safari-disabled-color': platformScannerService.getPlatform() == Platform.Safari}"
                 [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue?.city"
                 [type]="inputType"
                 class="block w-full rounded-b-md border-0 py-1.5 pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 "
                 placeholder="City">
              </div>
            }
            <!-- DEFAULT: a plain <input> whose [type] is whatever `inputType` happens to be (text, number,
                 password, date, datetime-local, …). -->
            @default {
              <input #SettingsInput
                     (ngModelChange)="setNewValueEvent($event)"
                     [attr.aria-label]="title"
                     [disabled]="!settingsInputElementModel.changeableProperties.editMode"
                     [ngClass]="{' safari-disabled-color': platformScannerService.getPlatform() == Platform.Safari,'pt-2':platformScannerService.getPlatform() == Platform.Safari&&inputType=='datetime-local','py-1.5':!(platformScannerService.getPlatform() == Platform.Safari&&inputType=='datetime-local')}"
                     [ngModel]="settingsInputElementModel.changeableProperties.newPropertyValue"
                     [type]="inputType"
                     class="block w-full rounded-md border-0  pl-9 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-theme-primary-700 sm:text-sm sm:leading-6 bg-white disabled:!bg-gray-200 ">
            }
          }
        </div>
      }
    </div>

    @if (['separator'].indexOf(inputType) < 0) {
      @if (!settingsInputElementModel.changeableProperties.editMode) {
      <a [ngClass]="{'pointer-events-none opacity-0': ['button', 'dropdown'].indexOf(inputType) > -1}"
         (click)="enableEditMode()"
         class="select-none text-gray-600 hover:text-gray-900 cursor-pointer ">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="bi bi-pen"
             viewBox="0 0 16 16">
          <path
            d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
        </svg>
      </a>
      }
      @if (settingsInputElementModel.changeableProperties.editMode || compare(settingsInputElementModel.changeableProperties.newPropertyValue, settingsInputElementModel.originalPropertyValue)) {
      <a (click)=" resetProperty()"
        class="select-none text-gray-600 hover:text-gray-900 cursor-pointer ">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="bi bi-pen"
             viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
          <path
            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
        </svg>
      </a>
      }
    }
  </dd>
</div>

<!--
<div class="pt-6 sm:flex items-center">
  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6 mb-6 sm:mb-0">{{propertyName}}</dt>
  <dd class="mt-1 flex justify-end gap-x-6 sm:mt-0 sm:flex-auto items-center">
    <input
      class="appearance-none block w-full  text-gray-700  border rounded py-3 px-4  leading-tight "
      #SettingsInput
      [disabled]="!changeableProperty.editMode"
      [ngModel]="displayValue"
      (ngModelChange)="setNewValueEvent($event)"
      [ngClass]="{'bg-green-200': validAndChangedInput === ChangeValueStatus.Changed, 'bg-red-200': validAndChangedInput === ChangeValueStatus.Invalid, 'bg-gray-200': validAndChangedInput === ChangeValueStatus.Unchanged}"
    >
    <a *ngIf="!changeableProperty.editMode"
       (click)="enableEditMode()"
       class="select-none text-gray-600 hover:text-gray-900 cursor-pointer ">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"  class="bi bi-pen"
           viewBox="0 0 16 16">
        <path
          d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z"/>
      </svg>
    </a>
    <a
      *ngIf="changeableProperty.editMode || changeableProperty.newPropertyValue != originalValue"
      (click)=" resetProperty()"
      class="select-none text-gray-600 hover:text-gray-900 cursor-pointer ">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"  class="bi bi-pen"
           viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
        <path
          d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
      </svg>
    </a>
  </dd>
</div>
-->
